import React, {useState, useEffect} from 'react'
import {useSelector} from 'react-redux'
import moment from 'moment'
import {makeStyles} from '@mui/styles'
import {rxrPrimaryColor} from '../../../assets/styles/color'
import {useHistory} from 'react-router-dom'
import Routes from '../../../constants/RouteConstants'
import {
  VendorServiceTypeCleaning,
  VendorServiceTypeDogwalking,
  VendorServiceTypeMassage,
  VendorServiceTypePersonalTraining,
} from '../../Services/ServicesConstants'
import {FormComponentPropTypes} from '../onboardingTypes'
import PropTypes from 'prop-types'
import {ONBOARDING_STATE_AVAILABLE} from '../../../constants/ModelConstants'

const serviceTypeToEnglishMap = {
  [VendorServiceTypeCleaning]: 'Cleaning',
  [VendorServiceTypeDogwalking]: 'Dog Walk',
  [VendorServiceTypeMassage]: 'Massage',
  [VendorServiceTypePersonalTraining]: 'Personal Training',
}

function BookVendorAppointment(props) {
  const classes = useStyles()
  const history = useHistory()

  const submission = props.submission
  const residentsLookup = useSelector(state => state.Residents.residentsLookup)
  const resident = residentsLookup[submission.residentId]

  const handleLinkClick = () => {
    history.push(Routes.constructPath(props.viewSingleRoute, {vendorAppointmentId: submission.vendorAppointmentId}))
  }

  if (!submission || !resident) return <div>Error loading the resident submission</div>

  if (submission.state === ONBOARDING_STATE_AVAILABLE)
    return <div>This is an optional task. This resident has not yet booked this service offering.</div>

  return (
    <div>
      A {submission.recurringLabel} {submission.serviceLabel} {serviceTypeToEnglishMap[props.serviceType]} was booked by{' '}
      {resident.displayName} for {moment(submission.appointmentStartAt).format('MMMM DD, YYYY')} between{' '}
      {moment(submission.appointmentStartAt).format('h:mma')} and {moment(submission.appointmentEndAt).format('h:mma')}. Click{' '}
      <a className={classes.link} onClick={handleLinkClick}>
        here
      </a>{' '}
      to view or make changes to the resident booking.
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  link: {
    color: rxrPrimaryColor,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))

export default BookVendorAppointment

BookVendorAppointment.propTypes = {
  ...FormComponentPropTypes,
  serviceType: PropTypes.string.isRequired,
  viewSingleRoute: PropTypes.string.isRequired,
}
